import { baseColors } from "./baseColors";
import { createPalette } from "./createPalette";

const primary = createPalette({ main: baseColors.navy });
const secondary = createPalette({
    main: baseColors.green,
    dark: "#8cf2c7",
    contrastText: baseColors.navy,
});
const alternate = createPalette({ main: baseColors.purple_alt });
const danger = createPalette({ main: baseColors.danger_red });
const flat_base = createPalette({ main: baseColors.cool_gray });
const flat = {
    ...flat_base,
    contrastText: baseColors.navy,
};

export const palette = {
    primary,
    secondary,
    alternate,
    danger,
    flat,
};
